import React, { Component } from "react";
import { Modal } from "antd";
import KeywordResearchTabs from "./KeywordResearchTabs";

class KeywordResearchSuggestionsModal extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };

    this.toggleModal = this.toggleModal.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onTabChange = this.onTabChange.bind(this);
  }

  toggleModal() {
    this.setState(prevState => ({
      visible: !prevState.visible
    }));
  }

  handleOpenModal() {
    this.toggleModal();
  }

  handleCloseModal() {
    this.toggleModal();
    this.props.onTypeChange(this.props.defaultType);
  }

  onTabChange(activeKey) {
    this.props.onTypeChange(activeKey);
  }

  render() {
    return (
      <React.Fragment>
        <span className="view-keyword-research" onClick={this.handleOpenModal}>
          {this.props.openLabel}
        </span>

        <Modal
          className="keyword-research-modal"
          title={this.props.modalTitle}
          visible={this.state.visible}
          onCancel={this.handleCloseModal}
          footer={null}
          width={1024}
          destroyOnClose>
          <KeywordResearchTabs
            onTabChange={key => this.onTabChange(key)}
            keyword={this.props.keyword}
            seoDb={this.props.seoDb}
            selectedResearchType={this.props.selectedType}
            researchTypes={this.props.allTypes}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

export default KeywordResearchSuggestionsModal;
